const chat = require('../../../../../components/chat/chat')
const chatHandler = require('../../../../../components/chat/chat-handler')
const handler = require('./customer-fullcont-handler')
const {
	buildChatCardWarning,
	readFullcontField,
	friendlySectionName,
} = require('../../../../../components/chat/chat-card-warning')

export function start(detail) {
	if (obj[detail.act]) {
		obj[detail.act].start(detail)
	}
}

const obj = {
	load: { start: (detail) => { load(detail) } },
	submit: { start: (detail) => { submit(detail) } },
	typing: { start: (detail) => { typing(detail) } },
	beforeChat: { start: (detail) => { beforeChat(detail) } },
}

const CUSTOMER_QUESTIONS = [
	'Total sold to the customer?',
	'Outstanding balance?',
	'Sales summary to the customer?',
]

function getGeneralQuestions(type) {
	if (type === 'customer') {
		return CUSTOMER_QUESTIONS
	}
}

function load(detail) {
	const fullcontActivo = document.getElementById(`${detail.dest}-fullcont`)
	const recordId = fullcontActivo.getAttribute('data-dbid')

	const details = fullcontActivo
		? [
				{ label: 'Name', value: readFullcontField(fullcontActivo, 'customer_form_name') },
				{ label: 'Phone', value: readFullcontField(fullcontActivo, 'customer_form_phone') },
				{ label: 'Contact', value: readFullcontField(fullcontActivo, 'customer_form_contact') },
				{ label: 'Credit limit', value: readFullcontField(fullcontActivo, 'customer_form_credit_limit') },
		  ]
		: []

	const cardWarning = buildChatCardWarning({
		entityDisplay: friendlySectionName(detail.dest),
		typeLabel: 'Saved customer',
		recordId: recordId || '—',
		details,
		scopeNote: 'The conversation corresponds only to this customer and to the history already saved here.',
	})

	if (recordId) {
		chat.start({
			dest: 'chat',
			act: 'quickview',
			actQuickview: 'show',
			type: 'customer',
			entity: 'customer',
			question: detail.question ?? '',
			generalQuestions: getGeneralQuestions('customer'),
			recordId: recordId,
			ev: detail.ev,
			cardWarning: cardWarning,
		})

		const msj = handler.getChatsFc()
		chat.start({
			dest: 'chat',
			act: 'load',
			chats: msj,
			generalQuestions: getGeneralQuestions('customer'),
			cardWarning: cardWarning,
		})
	}
}

function beforeChat(detail) {}

function submit(detail) {}

function typing(detail) {
	chatHandler.typing(detail)
}
